import React, { useState, useEffect } from "react";
import Empsidebar from "../components/Empsidebar";
import Empheader from "../components/Empheader";
import Uppercase from "../../admin/components/Uppercase";
import { useNavigate } from "react-router-dom";
import "../../admin/pages/Adminsettings.css";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";
import { toast } from "react-toastify";


function Empsettings() {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const openSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  const navigate = useNavigate();
  const [email, setEmail] = useState();
  useEffect(() => {
    const role = localStorage.getItem("role");
    if (role !== "employee") {
      navigate("/login");
    }
  }, [navigate]);
  const token = Cookies.get("token");
  useEffect(() => {
    if (!token) {
      navigate("/login");
    } else {
      const decoded = jwtDecode(token);
      setEmail(decoded.email);

      if (decoded.role !== "employee") {
        navigate("/login");
      }
    }
    fetchUsername();
  }, [token, navigate]);

  const fetchUsername = async () => {
    try {
      const response = await axios.get(" https://api.easytaxexperts.com/getempusername", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data.success) {
        setUsername(response.data.result[0].userName);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [username, setUsername] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleChangePassword = async (e) => {
    e.preventDefault();

    // Basic validation to check if new password matches the confirm password
    if (newPassword !== confirmPassword) {
      toast.error("New password and confirm password do not match.");
      return;
    }

    try {
      const response = await axios.put(" https://api.easytaxexperts.com/empupdatePassword", {
        email,
        newPassword,
      });
      if (response.data.success) {
        toast.success("Password updated successfully.");
        setNewPassword("");
        setConfirmPassword("");
      } else {
        toast.error("Failed to update password.");
      }
    } catch (error) {
      toast.error("An error occurred while updating the password.");
    }
  };


  return (
    <div>
      <Uppercase />
      <div className="invoice-grid-container">
        <Empheader openSidebar={openSidebar} />
        <Empsidebar
          openSidebarToggle={openSidebarToggle}
          openSidebar={openSidebar}
        />
        <main className="main-container mt-2">
          <div className="container">
            <div class=" row justify-content-center">
              <form
                className="col-lg-6 col-md-6 col-sm-12 custom-form"
                onSubmit={handleChangePassword}
              >
                <p class="custom-form-title">Change Password</p>
                <hr />
                <div className="mb-2">
                  <label class="input_label" for="email_field">
                    Username
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />{" "}
                  <span></span>
                </div>
               
                <div className="mb-2">
                  <label class="input_label" for="new_password_field">
                    New Password
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    placeholder="New password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />{" "}
                </div>
                <div className="mb-2">
                  <label class="input_label" for="reenter_password_field">
                    Re-Enter Password
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Re-Enter password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />{" "}
                </div>
                <button type="submit" className="btn btn-primary">
                  Change Password
                </button>
              </form>

              <div className="custom-form col-md-6 col-sm-12 col-lg-6">
                <h2 class="cardds-heading">Guidelines for Strong Password</h2>
                <hr />
                <ul class="guidelines-list">
                  <li>
                    At least 8 characters - the more characters, the better.
                  </li>
                  <li>A mixture of both uppercase and lowercase letters.</li>
                  <li>A mixture of letters and numbers.</li>
                  <li>
                    Avoid using common passwords like password, 12345, or
                    qwerty.
                  </li>
                  <li>
                    Inclusion of at least one special character like ! @#$%^&*()
                  </li>
                </ul>
                <hr />
                <h1 class="cardds-heading">Strong password examples are:</h1>
                <hr />
                <ul class="example-list">
                  <li>iLovemy$og!</li>
                  <li>Asdfg@?dfgFd</li>
                </ul>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default Empsettings;
